import React, { createContext, useContext } from "react";

const HeaderQuickSearchOverlayContext = createContext(false);

export function HeaderQuickSearchOverlayProvider({ active, children }) {
  return (
    <HeaderQuickSearchOverlayContext.Provider value={!!active}>
      {children}
    </HeaderQuickSearchOverlayContext.Provider>
  );
}

/** true כשחיפוש מהיר בראש המסך פתוח — מסתיר פסים קבועים בתחתית (למשל בפרטי מוצר). */
export function useHeaderQuickSearchOverlayActive() {
  return useContext(HeaderQuickSearchOverlayContext);
}
